/**
 * Format an ISO date string to a locale date-time string.
 * Returns empty string for invalid, empty, or epoch dates (starting with '0001').
 */
export const formatLastActivity = (iso: string): string => {
    if (!iso || iso.startsWith('0001')) return '';
    try {
        return new Date(iso).toLocaleString();
    } catch {
        return '';
    }
};
